import React, { useState } from "react";

import "./stylesAllGamesPopup.css";
import { X } from "react-feather";
import SaveButton from "../../../CommonComponents/SaveButton/SaveButton";

function AllGamesPopup({ isVisible, onClosePressed }) {
  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const maxChars = 50; // Máximo de caracteres permitidos

  const handleSubmit = async (e) => {
    e.preventDefault();

    return;
    setIsSubmitting(true);
    console.log("comment", comment);
    onClosePressed();

    return;
  };

  const handleClosePressed = () => {
    onClosePressed();
    setComment("");
  };

  const handleSetComment = (value) => {
    if (value.length <= maxChars) {
      setComment(value);
    }
  };

  if (!isVisible) return null;
  return (
    <div className="location-restrictions-popup">
      <div className="location-restrictions-panel">
        <div className="location-restrictions-panel-header">
          <h2>New Game</h2>
          <button className="close-button" onClick={handleClosePressed}>
            <X className="close-icon" />
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="event-code-input">
            <label htmlFor="eventCode">Name</label>
            <textarea
              id="eventCode"
              value={comment}
              placeholder="Game Name"
              onChange={(e) => handleSetComment(e.target.value)}
              rows="1"
              required
            />
            <div className="comment-counter">
              {comment.length}/{maxChars}
            </div>
          </div>
          <SaveButton
            isSubmitting={isSubmitting}
            buttonText="Add Game"
            cancelButton={true}
            cancelButtonText="No"
            callbackFunction={handleSubmit}
            callbackFunctionCancel={handleClosePressed}
          />
        </form>
      </div>
    </div>
  );
}

export default AllGamesPopup;
